import type { ConfirmDialogProps } from '@paid-ui/ui/confirm-dialog';

import { proxy } from 'valtio';

type ConfirmDialogManagerDetails = Omit<
  ConfirmDialogProps,
  'open' | 'onOpenChange' | 'trigger' | 'nested'
>;

export const confirmDialogManager = proxy({
  open: false,
  details: {} as ConfirmDialogManagerDetails,
});

export const openConfirmDialog = <T extends ConfirmDialogManagerDetails>(details?: T) => {
  confirmDialogManager.open = true;
  if (details !== undefined) {
    confirmDialogManager.details = details;
  }
};

export const closeConfirmDialog = () => {
  confirmDialogManager.open = false;
  confirmDialogManager.details = {
    title: '',
  };
};

export const toggleConfirmLoading = (loading: boolean, buttonText: string) => {
  const { open } = confirmDialogManager;
  if (!open) return;
  confirmDialogManager.details.confirmLoading = loading;
  confirmDialogManager.details.okButtonText = buttonText;
  // While the confirm action is in flight, lock down every other way out of the dialog
  // (close icon, cancel button, escape key) so the user cannot dismiss or cancel
  // mid-request.
  confirmDialogManager.details.showCloseIcon = !loading;
  confirmDialogManager.details.closeOnEscapeKeyDown = !loading;
  confirmDialogManager.details.cancelButtonProps = {
    ...confirmDialogManager.details.cancelButtonProps,
    disabled: loading,
  };
};
